<template>
    <div>
        <div class="col-md-7 noprint">
            <label class="control-label">BUSCA POR NOME DO CLIENTE</label>
            <input type="text" v-model="nome" class="form-control" >
        </div>

        <div class="col-md-5 noprint">
            <br/>
            <blockquote class="blockquote-reverse">
                Total de Contratos: <b>{{ getContratos.length }}</b>
            </blockquote>
        </div>

        <div class="col-md-12" style="margin-top: 20px">

            <button class="btn-danger btn btn-xs noprint" type="button" @click="print()">
                <i class="fa fa-print" aria-hidden="true"></i> IMPRIMIR
            </button><br/>

            <table id="mytable" class="table table-bordred ">

                <thead>
                <tr>
                    <th>CLIENTE</th>
                    <th>BAIRRO</th>
                    <th style="text-align: center;width: 140px" class="noprint">AÇÕES</th>
                </tr>
                </thead>

                <tbody>

                <tr v-for="r in getContratos" v-bind:key="r._id">
                    <td>
                        <b>{{ r.cliente.nome }}</b><br/>
                        <i>{{ r.endereco_instalacao.endereco }} - {{ r.endereco_instalacao.numero }}</i>
                    </td>
                    <td>
                        {{ r.endereco_instalacao.bairro }}<br/>
                        <i>{{ r.endereco_instalacao.cidade }} - {{ r.endereco_instalacao.estado }}</i>
                    </td>
                    <td class="noprint text-center">
                        <a :href="'#/contrato/add/' + r._id" class="btn btn-primary btn-xs">
                            ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        </a>
                    </td>
                </tr>

                </tbody>

            </table>

        </div>
    </div>
</template>
<script>
import { Contratos } from "../../../class/index";
export default {
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                return player.cliente.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadByContrato();
    },
    methods: {
        loadByContrato() {
            Contratos.allNoCaixa()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        },
        print() {
            window.print();
        }
    }
};
</script>
